import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropZone from 'UIComponents/drop/UIDropZone';
// @ts-expect-error not typed yet
import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
// @ts-expect-error not typed yet
import { getRowInnerWrapperElement } from 'ContentEditorUI/lib/layoutSection/dom';
import { EMPTY_PLACEHOLDER_ID_PARTIAL } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import Row from 'layout-data-lib/CellAndRowsTree/Row';
// @ts-expect-error not typed yet
import { getDndAreaElementForNode } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LayoutSectionEmptyRowPlaceholder extends Component {
  componentDidMount() {
    const {
      row
    } = this.props;
    this.getRowFromDOM(row);
  }
  componentDidUpdate(prevProps) {
    const {
      row
    } = this.props;
    if (prevProps.row !== row) {
      this.getRowFromDOM(row);
    }
  }
  componentWillUnmount() {
    this.rowChildElement = undefined;
  }
  getRowFromDOM(row) {
    const rowElement = getDndAreaElementForNode(row);
    if (rowElement) {
      this.rowChildElement = getRowInnerWrapperElement(rowElement);
    }
    return this.rowChildElement;
  }
  render() {
    const {
      row,
      isHovered
    } = this.props;

    // After a tree structure change we expect that the DOM may not have been updated yet.
    // So try again if needed, but bail silently if the DOM is still missing
    if (!this.rowChildElement && !this.getRowFromDOM(row)) {
      return null;
    }
    return /*#__PURE__*/_jsx(AfterBeginPortal, {
      id: `${EMPTY_PLACEHOLDER_ID_PARTIAL}-row-${row.getName()}`,
      namespace: NAMESPACE_CLASS,
      targetElement: this.rowChildElement,
      children: /*#__PURE__*/_jsx(UIDropZone, {
        className: "m-all-1",
        size: "sm",
        use: isHovered ? 'hover' : 'default',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.layoutSection.dropZone"
        })
      })
    });
  }
}
LayoutSectionEmptyRowPlaceholder.propTypes = {
  row: PropTypes.instanceOf(Row).isRequired,
  isHovered: PropTypes.bool.isRequired
};